import orderInstance from '../instance'

const updateOrderPayments = (orderId, data) => {
	return orderInstance.put(`/orders/${orderId}/payments`, data)
}

export default updateOrderPayments
